import "ladda/css/ladda.scss"

import * as Ladda from "ladda"

import { Offcanvas } from "bootstrap"
import bootbox from "bootbox"
import mixItUp from "mixitup"
import validate from "jquery-validation"
import { load } from "recaptcha-v3"

var is_mobile = false;

//Custom validation options
var validationOptions = {
    errorClass: "help-block",
    errorElement: "span",
    ignore: [], //Ignore nothing - -Not even hidden fields
    //ignore: "#jobProductTemplate *",
    //debug: true,
    highlight: function (element, errorClass, validClass) {
        var matchingNumberBox = $(element).attr("type") == "number";
        var matchingInputGroup = $(element).parent().hasClass("input-group");

        if (matchingNumberBox == true) { //Is a number box 
            if (matchingInputGroup == true) { //We're in an input group
                $(element).parents('.input-group').removeClass('has-success');
                $(element).parents('.input-group').addClass('has-error');
            } else { //Likely in a table cell
                $(element).parents('td').removeClass('has-success');
                $(element).parents('td').addClass('has-error');
            }
        } else {
            $(element).parents('.form-group').removeClass('has-success');
            $(element).parents('.form-group').addClass('has-error');
        }

        //Open tab with errors on:
        $(".tab-content").find("div.tab-pane:hidden:has(div.has-error)").each(function () {
            var id = $(this).attr("id");
            $('a[href="#' + id + '"]').tab('show');
        });

    },
    unhighlight: function (element, errorClass, validClass) {
        var matchingNumberBox = $(element).attr("type") == "number";
        var matchingInputGroup = $(element).parent().hasClass("input-group");

        if (matchingNumberBox == true) { //Is a number box 
            if (matchingInputGroup == true) { //We're in an input group
                $(element).parents('.input-group').removeClass('has-error');
                $(element).parents('.input-group').addClass('has-success');
            } else { //Likely in a table cell
                $(element).parents('td').removeClass('has-error');
                $(element).parents('td').addClass('has-success');
            }
        } else {
            $(element).parents('.form-group').removeClass('has-error');
            $(element).parents('.form-group').addClass('has-success');
        }
    },
    errorPlacement: function (error, element) {
        var matchingInputGroup = element.parent().hasClass("input-group");
        var matchingDropdown = element.next().hasClass("bootstrap-select");
        var matchingCheckbox = element.attr("type") == "checkbox";
        var matchingNumberBox = element.attr("type") == "number";
        var matchingCKEditor = $(element).hasClass("ckeditor");

        if (matchingNumberBox == true) { //Is a number box 
            //Do nothing -- do not place an error message

        } else if (matchingCKEditor == true) { //CKEditor box
            error.insertAfter(element.next());

        } else if (matchingInputGroup == true) { //uses bootstrap input grouping
            error.insertAfter(element.parent());

        } else if (matchingDropdown == true) { //Fancy dropdown box
            error.insertAfter(element.next());

        } else if (matchingCheckbox) { //Checkboxes
            error.insertBefore(element.parent("label").parent("div"));

        } else { //Standard text box
            error.insertAfter(element);
        };
    },

    invalidHandler: function (event, validator) {
        event.preventDefault();
        if (typeof Ladda !== "undefined") Ladda.stopAll()
        return false
    }
}

//Init Ladda buttons
const initLaddaButtons = () => {
    Array.from(document.getElementsByClassName("ladda-button")).forEach(button => {
        button.CDATA_SECTION_NODE.style = "zoom-in"
    })
    window.Ladda = Ladda
    Ladda.bind(".ladda-button")
}
initLaddaButtons();

//options: form, action, success, error
const handleAjaxForm = (options) => {

    let { form, action, success, error } = options
    if (!action) action = form.action

    const submitBtn = form.querySelector("button[type=submit]")
    submitBtn.dataset.style = "zoom-in"
    Ladda.bind(submitBtn)

    form.addEventListener("submit", function (e) {
        e.preventDefault();

        if (!$(form).valid()) return false;

        fetch(action, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
            },
            body: new URLSearchParams(serialiseForm(form))

        }).then(resp => {
            if (resp.ok) return resp.json();
            showAjaxFormError()

        }).then(data => {
            if (typeof Ladda !== "undefined") Ladda.stopAll()
            if (success) success(data);

        }).catch(err => {
            if (error) error(err)
        })

    }, true)
}

//Converts a form into serialised key pair items in JSON format
export const serialiseForm = function (form) {
    var obj = {}
    const formData = new FormData(form)
    for (var key of formData.keys()) {
        obj[key] = formData.get(key)
    }
    return obj
}

function prepareFormValidation(form) {
    $(form).validate(validationOptions);
}


$(document).ready(function () {

    //This must be re-run when a new form is created via JS.
    $(".validateForm").each(function () {
        prepareFormValidation($(this))
    });

    //Detect mobile devices
    if ($('#mobile-detect').css('display') == 'none') {
        is_mobile = true;
    }

    //FAQ accordians
    const faqSelect = document.getElementById("faqSelect");
    if (faqSelect) {
        const supportAccordion = document.getElementById("supportAccordion");
        const mixer = mixItUp(supportAccordion, {
            selectors: {
                target: ".accordion-item"
            },
            animation: {
                duration: 300
            }
        });
        faqSelect.addEventListener("change", (e) => {
            mixer.filter(e.target.value)
        })
    }

    //Product category sorting
    const orderbySelect = document.getElementById("orderby");
    if (orderbySelect) {
        orderbySelect.addEventListener("change", (e) => {
            const form = orderbySelect.closest("form")
            if (form) form.submit()
        });
    }

    //Region selector (auto submit)
    $("#region-select").on("change", function () {
        $(this).parents("form").submit();
    });


    //Init quick content form
    const offCanvas = document.getElementById("feedbackOffCanvas")
    const offCanvasContent = document.getElementById("offcanvasContent")
    let quickContactLoaded = false

    offCanvas.addEventListener("shown.bs.offcanvas", () => {
        if (!quickContactLoaded) {
            fetch("/ajax/quickContact")
                .then(resp => resp.text())
                .then(data => {
                    offCanvasContent.innerHTML = data
                    quickContactLoaded = true
                    setTimeout(() => {
                        $(offCanvasContent.querySelector("form")).validate(validationOptions);
                        handleAjaxForm({
                            form: offCanvasContent.querySelector("form"),
                            success: (data) => {
                                Ladda.stopAll()
                                Offcanvas.getInstance(document.getElementById("feedbackOffCanvas")).hide()
                                document.getElementById("feedback-btn").style.display = "none"
                                location.href = "/thankyou"
                                //bootbox.alert("Thank you for contacting us. We'll get back to you soon.");
                            },
                            error: (err) => {
                                Ladda.stopAll()
                                bootbox.alert({
                                    message: "There was an error processing your request. Please try again.",
                                    className: "bg-danger"
                                });
                            }
                        })
                    }, 0)
                })
        }
    })




    //Captcha forms
    if ($(".captcha-form").length > 0) {

        //Public site key from Google must be injected here:
        const captchaSystem = load("6LcnlgErAAAAAAcz66zZ1LP8lkYKIq_b1S_7kOXE")

        $(".captcha-form").on("submit", function (e) {
            e.preventDefault()
            const $form = $(this)

            //Standard form validation
            prepareFormValidation($form)
            if (!$form.valid()) return

            const action = $form.data("captcha-action")
            //const l = Ladda.create($form.find("button[type='submit']")[0])
            _blockForm($form)


            captchaSystem.then((recaptcha) => {
                recaptcha.execute(action).then(token => {
                    $form.find("input[name='captcha_response']")[0].value = token
                    e.target.submit()
                })
            })
        })

        const _blockForm = function ($form) {
            //btn.start()
            $form.find("input,textarea,submit,button,a").attr("readonly", true)
        }


    }



});
